module.exports = __webpack_public_path__ + "img/play.7df8e653.svg";